import { useState, useCallback } from 'react';
import { fetchMembers } from '../services/api';

export function useMembers(config, filters) {
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const loadMembers = useCallback(async (clearFirst = false) => {
        try {
            if (clearFirst) {
                setMembers([]); // Clear existing members when applying new filters
            }
            setLoading(true);
            setError(null);
            
            // Debug logging
            console.log('Loading members with filters:', filters);
            console.log('Form ID:', config.formId);
            console.log('Search term:', searchTerm);
            console.log('Filters object keys:', Object.keys(filters));
            console.log('Filters object values:', Object.values(filters));
            
            const data = await fetchMembers({
                formId: config.formId,
                search: searchTerm,
                filters: filters,
                includeNoLocation: config.includeNoLocation !== undefined ? config.includeNoLocation : false,
                limit: config.resultLimit || null
            });
            
            setMembers(data.members || []);
        } catch (err) {
            setError(err.message || 'Failed to load members');
            console.error('Error loading members:', err);
        } finally {
            setLoading(false);
        }
    }, [config.formId, searchTerm, filters]);

    return {
        members,
        loading,
        error,
        searchTerm,
        setSearchTerm,
        loadMembers
    };
}
